define('loader',[
    'edap-ua-integration',
    'edap-tagmanager-integration',
    'edap-optimizely-integration',
    'edap-demo-integration',
    'init' // should always be last to make sure all other integrations have registered their callbacks
], function(inittedEdap) {
    'use strict';

    return inittedEdap;
});

